import { render, staticRenderFns } from "./OrphanDetails.vue?vue&type=template&id=2fe80f92&"
import script from "./OrphanDetails.vue?vue&type=script&lang=js&"
export * from "./OrphanDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2fe80f92')) {
      api.createRecord('2fe80f92', component.options)
    } else {
      api.reload('2fe80f92', component.options)
    }
    module.hot.accept("./OrphanDetails.vue?vue&type=template&id=2fe80f92&", function () {
      api.rerender('2fe80f92', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orphan/OrphanDetails.vue"
export default component.exports